import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { IconComponent } from '../icon/icon.component';
import { NgIf } from '@angular/common';
import { TableModule } from 'primeng/table';
import { ListContainerComponent } from '../list-container/list-container.component';

@Component({
    selector: '[lSortable]',
    templateUrl: './sort-icon.component.html',
    imports: [
        IconComponent,
        NgIf,
        TableModule
    ]
})
export class SortIconComponent implements OnInit {

  constructor(
    private readonly listContainer: ListContainerComponent<any>
  ) { }

  @Input({ required: true, alias: 'lSortable' })
  public field!: string;

  @Output()
  public onChangeOrder = new EventEmitter<1 | -1 | 0>();

  public simpleOrder: 1 | -1 | 0 = 0;

  public ngOnInit(): void {
    this.listContainer.registerSortableColumn(this);
  }

  public handlerOrder(): void {
    if (this.simpleOrder === 0) {
      this.simpleOrder = -1;
    } else if (this.simpleOrder === -1) {
      this.simpleOrder = 1;
    } else if (this.simpleOrder === 1) {
      this.simpleOrder = 0;
    }

    this.onChangeOrder.emit(this.simpleOrder);
  }

}
